module.exports = __webpack_public_path__ + "img/mopani-pharmacy.6bc476a1.svg";